// ** Lesson header: module eyebrow + chapter crumb + prominent lesson title (style-v3)
import React from "react";

import Box from "@mui/material/Box";

function LessonTitle({ chapterName, lessonName, activeChapterIndex, showChapterNumbers }) {
  return (
    <Box className="lesson-head" sx={{ px: 4, pt: 4, pb: 1 }}>
      {(showChapterNumbers || chapterName) && (
        <div className="lesson-head__crumb">
          {showChapterNumbers && <span className="lesson-head__module">MÓDULO {activeChapterIndex + 1}</span>}
          {showChapterNumbers && chapterName && <span className="lesson-head__dot" />}
          {chapterName && <span className="lesson-head__chapter">{chapterName}</span>}
        </div>
      )}
      <h1 className="lesson-head__title">{lessonName}</h1>
    </Box>
  );
}

export default LessonTitle;
